import { IntlShape, defineMessages } from 'react-intl';

import type { ColorValue } from '../modules/car/api/hardcoded-make-models';

const COLORS_MESSAGES = defineMessages<ColorValue>({
  '#000000': { defaultMessage: 'Black', id: 'BG953b', description: 'Black color #000000' },
  '#808080': { defaultMessage: 'Gray', id: 'apcoLv', description: 'Gray color #808080' },
  '#C0C0C0': { defaultMessage: 'Silver', id: 'YgjZ+V', description: 'Silver color #C0C0C0' },
  '#FFFFFF': { defaultMessage: 'White', id: 'hRv0BI', description: 'White color #FFFFFF' },
  '#F5F5DC': { defaultMessage: 'Beige', id: 'v5Zfdd', description: 'Beige color #F5F5DC' },
  '#49311C': { defaultMessage: 'Brown', id: 'pYRKYS', description: 'Brown color #49311C' },
  '#354542': {
    defaultMessage: 'Green',
    id: 'global_color_green',
    description: 'Green color #354542',
  },
  '#00007F': {
    defaultMessage: 'Dark Blue',
    id: 'ec4H01',
    description: 'Dark Blue color #00007F',
  },
  '#1A5091': {
    defaultMessage: 'Nautic Blue',
    id: 'Pa6/xm',
    description: 'Nautic Blue color #1A5091',
  },
  '#800020': {
    defaultMessage: 'Burgundy',
    id: 'GvfXSo',
    description: 'Burgundy color #800020',
  },
  '#875341': {
    defaultMessage: 'Sienna Brown',
    id: 'global_color_sienna_brown',
    description: 'Sienna Brown color #875341',
  },
  '#0A0A0A': {
    defaultMessage: 'Nappa Leather Black',
    id: 'global_color_nappa_leather_black',
    description: 'Interior color option: Nappa Leather Black',
  },
  '#4A2C23': {
    defaultMessage: 'Nappa Leather Sienna Brown/Black',
    id: 'global_color_nappa_leather_sienna_brown_black',
    description: 'Interior color option: Nappa Leather Sienna Brown/Black',
  },
  '#E6D8C5': {
    defaultMessage: 'Beige Fabric Roof Liner',
    id: 'global_color_beige_fabric_roof_liner',
    description: 'Interior color option: Beige Fabric Roof Liner',
  },
  '#F2F2F2': {
    defaultMessage: 'Nappa Leather Porcelain',
    id: 'global_color_nappa_leather_porcelain',
    description: 'Interior color option: Nappa Leather Porcelain',
  },
  '#EAD8B0': {
    defaultMessage: 'Nappa Leather Beige Silk',
    id: 'global_color_nappa_leather_beige_silk',
    description: 'Interior color option: Nappa Leather Beige Silk',
  },
  '#B0A69A': {
    defaultMessage: 'Nappa Leather Macchiato Beige/Magma Grey',
    id: 'global_color_nappa_leather_macchiato_beige_magma_grey',
    description: 'Interior color option: Nappa Leather Macchiato Beige/Magma Grey',
  },
  '#1A1A1A': {
    defaultMessage: 'Backen Black',
    id: 'global_color_backen_black',
    description: 'Interior color option: Backen Black',
  },
  '#A0A0A0': {
    defaultMessage: 'Sheer Gray',
    id: 'global_color_sheer_gray',
    description: 'Interior color option: Sheer Gray',
  },
  '#E1A9A1': {
    defaultMessage: 'Camelia',
    id: 'global_color_camelia',
    description: 'Interior color option: Camelia',
  },
  '#8B5A2B': {
    defaultMessage: 'Brandy',
    id: 'global_color_brandy',
    description: 'Interior color option: Brandy',
  },
  '#F1E7D6': {
    defaultMessage: 'Whisper Beige',
    id: 'global_color_whisper_beige',
    description: 'Interior color option: Whisper Beige',
  },
  '#343434': {
    defaultMessage: 'Jet Black',
    id: 'global_color_jet_black',
    description: 'Jet Black color #343434',
  },
});

const getLocalizedColorName = (colorHex: string, intl: IntlShape): string => {
  if (colorHex in COLORS_MESSAGES) {
    return intl.formatMessage(COLORS_MESSAGES[colorHex as ColorValue]);
  }

  return colorHex;
};

export { getLocalizedColorName };
